// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2461006d","239":"14b92be5","667":"79a8db7f"}[chunkId] + ".chunk.js";
};